import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useReducer } from "react";
export const DraggableReducer = (state, action)=>{
    switch(action.type){
        case "picked_up":
            if (action.index === undefined) {
                return state;
            }
            return {
                ...state,
                pickedUpIndex: action.index,
                hoveringIndex: undefined
            };
        case "hovering":
            if (action.index === undefined) {
                return state;
            }
            return {
                ...state,
                hoveringIndex: action.index
            };
        case "dropped":
            let toIndex = state.hoveringIndex === undefined ? -1 : state.hoveringIndex;
            const fromIndex = state.pickedUpIndex === undefined ? -1 : state.pickedUpIndex;
            console.log("[!] [draggable] dropped", fromIndex, toIndex);
            //if to index is the length, then we are dropping at the end of the list
            if (toIndex === state.values.length) {
                toIndex = state.values.length - 1;
            } else if (toIndex && fromIndex < toIndex) {
                toIndex -= 1;
            }
            let values = state.values;
            if (fromIndex != -1 && fromIndex < state.values.length) {
                const updatedValues = [
                    ...state.values
                ];
                const [moved] = updatedValues.splice(fromIndex, 1);
                if (moved) {
                    updatedValues.splice(toIndex, 0, moved);
                    values = updatedValues;
                }
            }
            state.onReorder(values);
            return {
                ...state,
                hoveringIndex: undefined,
                pickedUpIndex: undefined,
                values: values
            };
        case "reload_values":
            return {
                ...state,
                hoveringIndex: undefined,
                pickedUpIndex: undefined,
                values: action.values || state.values || []
            };
        default:
            return state;
    }
};
export const Draggable = ({ item, render, state, index, move, dispatch })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: `relative py-1 w-full ${state.pickedUpIndex !== undefined ? "transition-all" : ""} ${index == state.pickedUpIndex ? "transition-all opacity-0" : ""} ${move == "up" ? "transition-all translate-y-[-100%]" : ""} ${move == "down" ? "transition-all translate-y-[100%]" : ""}`,
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full",
            draggable: "true",
            onDragStart: (e)=>{
                dispatch({
                    type: "picked_up",
                    index
                });
                e.dataTransfer.effectAllowed = "move";
            },
            onDragOver: (e)=>{
                e.preventDefault();
                const rect = e.currentTarget.getBoundingClientRect();
                const enteredFromTop = e.clientY < rect.top + rect.height / 2;
                const hoverIndex = enteredFromTop ? index : index + 1;
                if (hoverIndex !== state.hoveringIndex) {
                    dispatch({
                        type: "hovering",
                        index: hoverIndex
                    });
                }
            },
            onDragEnd: (e)=>{
                e.preventDefault();
                dispatch({
                    type: "dropped",
                    index
                });
            },
            children: render(item, index, state.pickedUpIndex)
        })
    });
};
export const DraggableList = ({ values, render, onReorder, renderKey })=>{
    const initialState = useMemo(()=>{
        return {
            values,
            onReorder
        };
    }, []);
    const [state, dispatch] = useReducer(DraggableReducer, initialState);
    const pickedUpIndex = state.pickedUpIndex;
    const hoveringIndex = state.hoveringIndex;
    const disposition = useMemo(()=>{
        if (pickedUpIndex === undefined || hoveringIndex === undefined || pickedUpIndex === -1 || hoveringIndex === -1) {
            return {
                indeces: [],
                direction: "none"
            };
        } else {
            // array of indeces between pickedUpIndex and hoveringIndex
            const indeces = Array.from({
                length: Math.abs(pickedUpIndex - hoveringIndex)
            }, (_, i)=>i + Math.min(pickedUpIndex, hoveringIndex));
            const direction = pickedUpIndex < hoveringIndex ? "up" : "down";
            return {
                indeces,
                direction
            };
        }
    }, [
        pickedUpIndex,
        hoveringIndex
    ]);
    useEffect(()=>{
        const needsRefresh = !renderKey || values.length !== state.values.length || values.some((item, index)=>{
            return state.values[index] && renderKey(item) !== renderKey(state.values[index]);
        });
        if (needsRefresh) {
            dispatch({
                type: "reload_values",
                values
            });
            console.log("[!] [draggable] reload_values");
        }
    }, [
        values
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full grid grid-cols-1 items-center justify-stretch",
        children: state.values.map((item, index)=>{
            return /*#__PURE__*/ _jsx(Draggable, {
                render: render,
                move: disposition.indeces.includes(index) && index != state.pickedUpIndex ? disposition.direction : "none",
                item: item,
                index: index,
                state: state,
                dispatch: dispatch
            }, index);
        })
    });
};
